export const MAIN_ROUTES = new Map([
  [
    "HOME",
    {
      ID: "_home",
      ITEMS: [],
      LABEL: "Home",
      PATH: "/",
      VALUE: "home",
    },
  ],
  [
    "PRODUCTS",
    {
      ID: "_products",
      ITEMS: [],
      LABEL: "Products",
      PATH: "/#_products",
      VALUE: "products",
    },
  ],
  [
    "PROJECTS",
    {
      ID: "_projects",
      ITEMS: [],
      LABEL: "Projects",
      PATH: "/projects",
      VALUE: "projects",
    },
  ],
  [
    "PUBLICATIONS",
    {
      ID: "_publications",
      ITEMS: [],
      LABEL: "Publications",
      PATH: "/publications",
      VALUE: "publications",
    },
  ],
  [
    "ABOUT",
    {
      ID: "_about",
      ITEMS: [],
      LABEL: "About Us",
      PATH: "/about",
      VALUE: "about",
    },
  ],
  [
    "PARTNERS",
    {
      ID: "_partners",
      ITEMS: [],
      LABEL: "Partners",
      PATH: "/#_partners",
      VALUE: "partners",
    },
  ],
  [
    "CONTACT",
    {
      ID: "_contact",
      ITEMS: [],
      LABEL: "Contact Us",
      PATH: "/contact",
      VALUE: "contact",
    },
  ],
  [
    "INTRODUCTION",
    {
      ID: "_introduction",
      ITEMS: [],
      LABEL: "Introduction",
      PATH: "/introduction",
      VALUE: "introduction",
    },
  ],
  [
    "VALUES",
    {
      ID: "_values",
      ITEMS: [],
      LABEL: "Values",
      PATH: "/values",
      VALUE: "values",
    },
  ],
  [
    "PRIVACY",
    {
      ID: "",
      ITEMS: [],
      LABEL: "privacy",
      PATH: "/privacy",
      VALUE: "privacy",
    },
  ],
]);
